module.exports = __webpack_public_path__ + "static/media/marinex_submit.254d3a6c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgs/marinex_submit.svg
// module id = 249
// module chunks = 0